<template>
  <div class="gdl-date-table">
    <Table
      ref="table"
      :columns="columnsDefExtended"
      :data="formatedData"
      :loading="loading"
      :row-class-name="getRowClassName"
      :sort="sort"
      :filters="filters"
      :highlight-row="false"
      size="small"
      class="gdl-iview-table"
      @sort-change="onSortChange"
      @filter-change="onFilterChange"
      @selected-change="onSelectedChange"
    >
      <div
        slot="footer"
        class="gdl-table-footer"
        style="display: flex; height: 48px;"
      >

        <template v-if="isSelection">
          <iSelect v-model="batchAction" style="width:120px; margin: 8px 16px;">
            <i-option v-if="printable" value="print-tag">Imprimer</i-option>
            <i-option v-if="deletable" value="delete">Supprimer</i-option>
            <i-option v-if="deletable" value="restore">Restaurer</i-option>
          </iSelect>
          <iButton
            type="primary"
            style="margin: 8px 0px;"
            @click="onBatchSelectionApply"
          >Appliquer</iButton>
        </template>

        <template v-else-if="enableNewButton">
          <iButton
            type="primary"
            style="margin: 8px 30px;"
            @click="$emit('createButton')"
          >Nouveau</iButton>
        </template>

        <div class="spacer"/>

        <iPage
          :current="pagination.page"
          :total="pagination.count"
          :page-size="pagination.per"
          :page-size-opts="pagination.perOptions"
          show-elevator
          show-sizer
          show-total
          transfer
          size="small"
          style="user-select: none;"
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </Table>
  </div>
</template>

<script>
import _ from 'lodash';

import Table from './data-table/table-gdl';
import DataTableColumnsSelector from './data-table/DataTableColumnsSelector.vue';
import DataTableRowMenu from './data-table/DataTableRowMenu.vue';

export default {
  name: 'GdlDataTable',
  components: { Table, DataTableColumnsSelector, DataTableRowMenu },
  props: {
    data: { type: Array, default: () => [] },
    columns: { type: Array, required: true },
    columnsOrder: { type: Array, default: undefined },
    loading: { type: Boolean, default: false },
    pagination: { type: Object, default: () => ({}) },
    sort: { type: Array, default: () => [] },
    filters: { type: Object, default: () => ({}) },
    showDeleted: { type: Boolean, default: false },

    editable: { type: Boolean, default: true },
    deletable: { type: Boolean, default: true },
    printable: { type: Boolean, default: false },

    enableSelection: { type: Boolean, default: true },
    enableNewButton: { type: Boolean, default: true },
  },
  data() {
    return {
      batchAction: undefined,
      isSelection: false,
    };
  },
  computed: {
    formatedData() {
      return this.data.map(({ id, ...row }) => {
        const item = { id };
        this.columns.forEach((config) => {
          const { key, prop, formatterFn } = config;
          const value = _.get(row, prop);
          item[key] = formatterFn && !_.isNil(value) ?
            formatterFn(value)
            : value;
        });
        return item;
      });
    },
    selectionColumnDef() {
      return {
        type: 'selection',
        width: 60,
        align: 'center',
      };
    },
    actionsColumnDef() {
      return {
        width: 40,
        className: 'gdl-action-cell',
        key: 'action',
        align: 'right',
        // fixed: 'right',
        render: (h, params) => {
          const { row } = params;
          return (
            <DataTableRowMenu
              row={ row }
              editable={ this.editable }
              deletable={ this.deletable }
              on-selected={ this.onMenuSelected }
            />
          );
        },
        renderHeader: (h) => { // eslint-disable-line
          return (
            <DataTableColumnsSelector
              columns={ this.columnsDef }
              selected={ this.columnsOrder }
              deletable={ this.deletable }
              show-deleted={ this.showDeleted }
              on-show-deleted-change={ this.onShowDeletedChange }
              on-change={ this.onColumnsOrderChange } />
          );
        },
      };
    },
    columnsDef() {
      return this.columns.map((column) => {
        const {
          label, sort, filter, ...options
        } = column;
        return {
          ...{
            // type: 'index|selection|expand|html',
            // width,
            // align: 'left|right|center',
            // className,
            // fixed: 'left|right',
            ellipsis: true,
            // render(h, props) => {}
            // renderHeader(h, props) => {}
            // sortable: 'custom',
            // sortMethod(a, b, type) => {}
            // sortType: 'asc|desc'
            // filters: [{ label: '', value: ''}]
            // filterMethod
            // filterMultiple
            // filteredValue
            // filterRemote
          },
          title: label ? this.$t(label) : '',
          sortable: sort !== false && 'custom',
          filterable: filter !== false && filter,
          ...options,
        };
      });
    },
    columnsDefByKey() { return _.keyBy(this.columnsDef, 'key'); },
    columnsDefOrdered() {
      return this.columnsOrder ?
        _.compact(this.columnsOrder.map(key => this.columnsDefByKey[key])) :
        this.columnsDef;
    },
    columnsDefExtended() {
      return [
        this.enableSelection && this.selectionColumnDef,
        ...this.columnsDefOrdered,
        this.actionsColumnDef,
      ].filter($ => !!$);
    },
  },
  methods: {
    getRowClassName(row) {
      const classNames = [];
      if (row.deletedAt) classNames.push('gdl-deleted-row');
      return classNames.join(' ');
    },
    clearbatchAction() {
      this.batchAction = null;
    },
    onBatchSelectionApply() {
      const action = this.batchAction;
      if (!action) return;
      const { selected } = this.$refs.table;
      this.$emit('batch-action', { selected, action });
    },
    onColumnsOrderChange(selected) {
      this.$emit('columns-order-change', selected);
    },
    onPageChange(page) {
      this.$emit('pagination-change', { page });
    },
    onShowDeletedChange(deleted) {
      this.$emit('show-deleted-change', deleted);
    },
    onPageSizeChange(per) {
      this.$emit('pagination-change', { per });
    },
    onSortChange(sort) {
      this.$emit('sort-change', sort);
    },
    onFilterChange(filter) {
      this.$emit('filter-change', filter);
    },
    onSelectedChange(selection) {
      this.isSelection = !!selection.length;
      if (!this.isSelection) this.clearbatchAction();
    },
    onMenuSelected({ action, selected }) {
      if (!action) return;
      this.$emit('menu-action', { action, selected });
    },
  },
};
</script>

<style>
.gdl-action-cell .ivu-table-cell {
  padding-left: 0px;
  padding-right: 0px;
}

th .ivu-table-cell {
  overflow-wrap: normal;
  word-wrap: normal;

  word-break: keep-all;
  /* hyphens: auto; */
}

.gdl-iview-table .ivu-table {
  display: flex;
  flex-direction: column;
}

 .ivu-table-header,
.gdl-iview-table .ivu-table-footer {
  flex: 0 0 auto;
}
.gdl-iview-table .ivu-table-body,
.gdl-iview-table .ivu-table-tip {
  position: relative;
  flex: auto;
  overflow: auto;
}

.gdl-iview-table .ivu-table-header .ivu-table-cell span:first-child {
  display: inline-block;
}
.gdl-iview-table .ivu-table-header .ivu-table-cell span:first-child:first-letter {
  text-transform: uppercase;
}

.gdl-iview-table .gdl-deleted-row td{
  background-color: #cccccc1c;
  color: #bbbec4;
  text-decoration: line-through;
}
</style>

<style scoped>
.gdl-iview-table {
  height: 100%;
  width: 100%;
}

.gdl-table-footer {
  border-top: 1px solid #e9eaec;
}
</style>
